// Copyright 2018-2024 contributors to the Marquez project
// SPDX-License-Identifier: Apache-2.0

export const APPLICATION_ERROR = 'APPLICATION_ERROR'
export const DIALOG_TOGGLE = 'DIALOG_TOGGLE'

// runs
export const FETCH_RUNS = 'FETCH_RUNS'
export const FETCH_RUNS_SUCCESS = 'FETCH_RUNS_SUCCESS'
export const RESET_RUNS = 'RESET_RUNS'
export const FETCH_LATEST_RUNS = 'FETCH_LATEST_RUNS'
export const FETCH_LATEST_RUNS_SUCCESS = 'FETCH_LATEST_RUNS_SUCCESS'

export const FETCH_NAMESPACES_SUCCESS = 'FETCH_NAMESPACES_SUCCESS'
export const SELECT_NAMESPACE = 'SELECT_NAMESPACE'

export const SET_SELECTED_NODE = 'SET_SELECTED_NODE'

export const SET_BOTTOM_BAR_HEIGHT = 'SET_BOTTOM_BAR_HEIGHT'

export const SET_TAB_INDEX = 'SET_TAB_INDEX'

// jobs
export const FETCH_JOBS = 'FETCH_JOBS'
export const FETCH_JOBS_SUCCESS = 'FETCH_JOBS_SUCCESS'
export const RESET_JOBS = 'RESET_JOBS'
export const DELETE_JOB = 'DELETE_JOB'
export const DELETE_JOB_SUCCESS = 'DELETE_JOB_SUCCESS'
export const FETCH_JOB = 'FETCH_JOB'
export const FETCH_JOB_SUCCESS = 'FETCH_JOB_SUCCESS'
export const ADD_JOB_TAG = 'ADD_JOB_TAG'
export const ADD_JOB_TAG_SUCCESS = 'ADD_JOB_TAG_SUCCESS'
export const DELETE_JOB_TAG = 'DELETE_JOB_TAG'
export const DELETE_JOB_TAG_SUCCESS = 'DELETE_JOB_TAG_SUCCESS'

// datasets
export const FETCH_DATASETS = 'FETCH_DATASETS'
export const FETCH_DATASET = 'FETCH_DATASET'
export const FETCH_DATASETS_SUCCESS = 'FETCH_DATASETS_SUCCESS'
export const FETCH_DATASET_SUCCESS = 'FETCH_DATASET_SUCCESS'
export const RESET_DATASETS = 'RESET_DATASETS'
export const RESET_DATASET = 'RESET_DATASET'
export const FETCH_DATASET_VERSIONS = 'FETCH_DATASET_VERSIONS'
export const FETCH_DATASET_VERSIONS_SUCCESS = 'FETCH_DATASET_VERSIONS_SUCCESS'
export const RESET_DATASET_VERSIONS = 'RESET_DATASET_VERSIONS'
export const DELETE_DATASET = 'DELETE_DATASET'
export const DELETE_DATASET_SUCCESS = 'DELETE_DATASET_SUCCESS'
export const DELETE_DATASET_TAG = 'DELETE_DATASET_TAG'
export const DELETE_DATASET_TAG_SUCCESS = 'DELETE_DATASET_TAG_SUCCESS'
export const ADD_DATASET_TAG = 'ADD_DATASET_TAG'
export const ADD_DATASET_TAG_SUCCESS = 'ADD_DATASET_TAG_SUCCESS'
export const DELETE_DATASET_FIELD_TAG = 'DELETE_DATASET_FIELD_TAG'
export const DELETE_DATASET_FIELD_TAG_SUCCESS = 'DELETE_DATASET_FIELD_TAG_SUCCESS'
export const ADD_DATASET_FIELD_TAG = 'ADD_DATASET_FIELD_TAG'
export const ADD_DATASET_FIELD_TAG_SUCCESS = 'ADD_DATASET_FIELD_TAG_SUCCESS'
export const FETCH_INITIAL_DATASET_VERSIONS = 'FETCH_INITIAL_DATASET_VERSIONS'
export const FETCH_INITIAL_DATASET_VERSIONS_SUCCESS = 'FETCH_INITIAL_DATASET_VERSIONS_SUCCESS'

// events
export const FETCH_EVENTS = 'FETCH_EVENTS'
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS'
export const RESET_EVENTS = 'RESET_EVENTS'

// lineage
export const FETCH_LINEAGE = 'FETCH_LINEAGE'
export const FETCH_LINEAGE_SUCCESS = 'FETCH_LINEAGE_SUCCESS'
export const RESET_LINEAGE = 'RESET_LINEAGE'
export const SET_LINEAGE_GRAPH_DEPTH = 'SET_LINEAGE_GRAPH_DEPTH'
export const SET_SHOW_FULL_GRAPH = 'SET_SHOW_FULL_GRAPH'

// search
export const FETCH_SEARCH = 'FETCH_SEARCH'
export const FETCH_SEARCH_SUCCESS = 'FETCH_SEARCH _SUCCESS'

// OpenSearch
export const FETCH_OPEN_SEARCH_JOBS = 'FETCH_OPEN_SEARCH_JOBS'
export const FETCH_OPEN_SEARCH_JOBS_SUCCESS = 'FETCH_OPEN_SEARCH_JOBS_SUCCESS'
export const FETCH_OPEN_SEARCH_DATASETS = 'FETCH_OPEN_SEARCH_DATASETS'
export const FETCH_OPEN_SEARCH_DATASETS_SUCCESS = 'FETCH_OPEN_SEARCH_DATASETS_SUCCESS'

// facets
export const FETCH_RUN_FACETS = 'FETCH_RUN_FACETS'
export const FETCH_JOB_FACETS = 'FETCH_JOB_FACETS'
export const FETCH_FACETS_SUCCESS = 'FETCH_FACETS_SUCCESS'
export const RESET_FACETS = 'RESET_FACETS'

// tags
export const FETCH_TAGS = 'FETCH_TAGS'
export const FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS'
export const ADD_TAGS = 'ADD_TAGS'
export const ADD_TAGS_SUCCESS = 'ADD_TAGS_SUCCESS'

// column lineage
export const FETCH_COLUMN_LINEAGE = 'FETCH_COLUMN_LINEAGE'
export const FETCH_COLUMN_LINEAGE_SUCCESS = 'FETCH_COLUMN_LINEAGE_SUCCESS'
export const SET_COLUMN_LINEAGE_GRAPH_DEPTH = 'SET_COLUMN_LINEAGE_GRAPH_DEPTH'

// lineage metrics
export const FETCH_LINEAGE_METRICS = 'FETCH_LINEAGE_METRICS'
export const FETCH_LINEAGE_METRICS_SUCCESS = 'FETCH_LINEAGE_METRICS_SUCCESS'

// job metrics
export const FETCH_JOB_METRICS = 'FETCH_JOB_METRICS'
export const FETCH_JOB_METRICS_SUCCESS = 'FETCH_JOB_METRICS_SUCCESS'

// dataset metrics
export const FETCH_DATASET_METRICS = 'FETCH_DATASET_METRICS'
export const FETCH_DATASET_METRICS_SUCCESS = 'FETCH_DATASET_METRICS_SUCCESS'

// source metrics
export const FETCH_SOURCE_METRICS = 'FETCH_SOURCE_METRICS'
export const FETCH_SOURCE_METRICS_SUCCESS = 'FETCH_SOURCE_METRICS_SUCCESS'

// jobs by state
export const FETCH_JOBS_BY_STATE = 'FETCH_JOBS_BY_STATE'
export const FETCH_JOBS_BY_STATE_SUCCESS = 'FETCH_JOBS_BY_STATE_SUCCESS'

// iframe by state
export const UPDATE_IFRAME_PROPERTIES = 'UPDATE_IFRAME_PROPERTIES'
export const UPDATE_IFRAME_PROPERTIES_SUCCESS = 'UPDATE_IFRAME_PROPERTIES_SUCCESS'